/**
 * AR-412: three-state header sort shared by the Finances tables.
 *
 *   1st tap on a column → ascending (A–Z / oldest first)
 *   2nd tap             → descending (Z–A / newest first)
 *   3rd tap             → back to the table's default order
 *
 * The old handlers started at descending and only toggled, so the first tap
 * on "Supplier" showed Z–A and there was no way back to the default order.
 */
export type SortDir = 'asc' | 'desc';

export interface SortState<K extends string> {
  sortBy: K;
  sortDir: SortDir;
}

export function nextSortState<K extends string>(
  current: SortState<K>,
  column: K,
  defaultSort: SortState<K>,
): SortState<K> {
  if (current.sortBy !== column) return { sortBy: column, sortDir: 'asc' };
  if (current.sortDir === 'asc') return { sortBy: column, sortDir: 'desc' };
  // Third tap returns to the default. When this column IS the default
  // (e.g. Departure desc), the default equals the current state, so restart
  // the cycle at ascending instead of appearing to do nothing.
  if (defaultSort.sortBy === column && defaultSort.sortDir === 'desc') {
    return { sortBy: column, sortDir: 'asc' };
  }
  return { ...defaultSort };
}
